import {
	triggerCompletePurchasesMarkAsDeliveredEvent,
	triggerCompletePurchasesUnmarkAsDeliveredEvent,
} from 'Services/analytics/events';

export const triggerDeliveredStatusSnowplowEvent = (deliveredStatus: boolean): void =>
	deliveredStatus ? triggerCompletePurchasesMarkAsDeliveredEvent() : triggerCompletePurchasesUnmarkAsDeliveredEvent();
